var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 512 512" },
      attrs: {
        id: "Capa_1",
        height: "14",
        version: "1.1",
        viewBox: "0 0 512 512",
        width: "14",
        x: "0px",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        y: "0px",
      },
    },
    [
      _c("g", { attrs: { fill: _vm.iconColor } }, [
        _c("g", [
          _c("g", [
            _c("path", {
              attrs: {
                d: "M362.667,0c-47.052,0-85.333,38.281-85.333,85.333c0,47.052,38.281,85.333,85.333,85.333\n\t\t\t\tc47.052,0,85.333-38.281,85.333-85.333C448,38.281,409.719,0,362.667,0z M362.667,149.333c-35.292,0-64-28.708-64-64\n\t\t\t\tc0-35.292,28.708-64,64-64s64,28.708,64,64C426.667,120.625,397.958,149.333,362.667,149.333z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M373.333,80.917V53.333c0-5.896-4.771-10.667-10.667-10.667S352,47.438,352,53.333v32c0,2.833,1.125,5.542,3.125,7.542\n\t\t\t\tl10.667,10.667c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125c4.167-4.167,4.167-10.917,0-15.083\n\t\t\t\tL373.333,80.917z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M268.906,277.333h-55.573C201.573,277.333,192,267.76,192,256v-85.333C192,147.135,172.865,128,149.333,128\n\t\t\t\ts-42.667,19.135-42.667,42.667V288c0,20.901,8.688,39.766,22.577,53.333h-22.577c-11.76,0-21.333-9.573-21.333-21.333V138.667\n\t\t\t\tc0-5.896-4.771-10.667-10.667-10.667C68.771,128,64,132.771,64,138.667V320c0,23.531,19.135,42.667,42.667,42.667H128v128H96\n\t\t\t\tc-5.896,0-10.667,4.771-10.667,10.667C85.333,507.229,90.104,512,96,512h85.333c5.896,0,10.667-4.771,10.667-10.667\n\t\t\t\tc0-5.896-4.771-10.667-10.667-10.667h-32v-128h32h21.333h32v116.156c0,18.292,14.885,33.177,33.177,33.177\n\t\t\t\tc16.927,0,31.115-12.688,32.969-29.354l18.875-148.563c0.208-1.885,0.313-3.771,0.313-5.656\n\t\t\t\tC320,300.25,297.083,277.333,268.906,277.333z M298.5,331.552l-18.875,148.573c-0.667,6.01-5.729,10.542-11.781,10.542\n\t\t\t\tc-6.531,0-11.844-5.313-11.844-11.844V352c0-5.896-4.771-10.667-10.667-10.667h-42.667h-21.333\n\t\t\t\tC151.927,341.333,128,317.406,128,288V170.667c0-11.76,9.573-21.333,21.333-21.333c11.76,0,21.333,9.573,21.333,21.333V256\n\t\t\t\tc0,23.531,19.135,42.667,42.667,42.667h55.573c16.406,0,29.76,13.354,29.76,29.76C298.667,329.521,298.604,330.615,298.5,331.552\n\t\t\t\tz",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M160,106.667c29.406,0,53.333-23.927,53.333-53.333S189.406,0,160,0s-53.333,23.927-53.333,53.333\n\t\t\t\tS130.594,106.667,160,106.667z M160,21.333c17.646,0,32,14.354,32,32c0,17.646-14.354,32-32,32s-32-14.354-32-32\n\t\t\t\tC128,35.688,142.354,21.333,160,21.333z",
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }